/******************************************
*  Author : Riccardo Di Dato
*  Created On : Thu Apr 28 2022
*  File : index.ts
*******************************************/
import { isFunction, isString } from '../TypeChecking/index.js';
import { hasOwnProperty } from '../Utils/index.js';
/**
 * Mixin per implementare semplicemente {@link EventHandler}.
 * @author Riccardo Di Dato
 */
export function DOMEventHandlerMockMixin(Base) {
    return class Scaling extends Base {
        // Dato che i mixin non permettono private e protected usiamo il doppio underscore e nomi che rendano improbabili le collisioni
        /**
         * @internal
         */
        __ehand_listeners = {};
        /**
         * @internal
         */
        __addAction(event, action) {
            if (!hasOwnProperty(this.__ehand_listeners, event)) {
                this.__ehand_listeners[event] = [];
            }
            this.__ehand_listeners[event].push(action);
        }
        /**
         * @internal
         */
        __removeAction(event, action) {
            if (hasOwnProperty(this.__ehand_listeners, event)) {
                this.__ehand_listeners[event] = this.__ehand_listeners[event].filter(e => e !== action);
            }
        }
        on(eventName, callback) {
            this.__addAction(eventName, callback);
        }
        off(evtOrAct, callback) {
            if (callback && isString(evtOrAct)) {
                this.__removeAction(evtOrAct, callback);
            }
            else if (isFunction(evtOrAct)) {
                Object.keys(this.__ehand_listeners).forEach(k => {
                    this.__removeAction(k, evtOrAct);
                });
            }
        }
        trigger(eventName, data) {
            if (hasOwnProperty(this.__ehand_listeners, eventName)) {
                this.__ehand_listeners[eventName].forEach((cb) => {
                    cb(data);
                });
            }
        }
        one(eventName, callback) {
            const finalFunction = (data) => {
                this.off(eventName, finalFunction);
                callback(data);
            };
            this.on(eventName, finalFunction);
        }
    };
}
